import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "onboarding-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title-container" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "footer pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.currentStep > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "back-button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevStep && _ctx.prevStep(...args)))
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "pi pi-chevron-left" }, null, -1)
          ])))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.steps[_ctx.currentStep].title), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.steps[_ctx.currentStep].description), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.steps[_ctx.currentStep].component)))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        class: "next-button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)))
      }, _toDisplayString(_ctx.currentStep === _ctx.steps.length - 1 ? "Готово" : "Далее"), 1)
    ])
  ]))
}